import { render, staticRenderFns } from "./AprovarOperacaoMonitor.vue?vue&type=template&id=21518b6c&scoped=true&"
import script from "./AprovarOperacaoMonitor.vue?vue&type=script&lang=js&"
export * from "./AprovarOperacaoMonitor.vue?vue&type=script&lang=js&"
import style0 from "./AprovarOperacaoMonitor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AprovarOperacaoMonitor.vue?vue&type=style&index=1&id=21518b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21518b6c",
  null
  
)

export default component.exports